import { ReactNode } from 'react';
import { Icon, IconButton, Theme, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';

import { useDrawerContext } from '../contexts';


interface ILayoutBaseDePaginaProps {
    children: React.ReactNode
    barraDeFerramentas?: ReactNode;
}

export const LayoutBaseDeDashboard: React.FC<ILayoutBaseDePaginaProps> = ({ children, barraDeFerramentas  }) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const theme = useTheme();

  const { toggleDrawerOpen } = useDrawerContext();

  return (
    <Box  height="100%" display="flex" flexDirection="column"  >
      <Box  display="flex" alignItems="center"  height={theme.spacing(smDown ? 6 : mdDown ? 8 : 0)}>
        {smDown && (
          <IconButton onClick={toggleDrawerOpen}>
            <Icon>menu</Icon>
          </IconButton>
        )}
      </Box>

      {barraDeFerramentas && (
        <Box>
          {barraDeFerramentas}
        </Box>
      )}

      <Box padding={1}  overflow="auto">
        {children}
      </Box>
    </Box>
  );
};